import {
  AddOneSlotToLoadingQueue,
  RemoveOneSlotToLoadingQueue,
} from "../../loading/loading.store";

import Service from "../../../../api/api-service";
import { ApiUrl } from "../../../../api/api-url";
import ShowNotification from "../../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../../utils/configuration";

const service = new Service();

export const GET_USER_OK = "GET_USER_OK";
export const GET_USER_ERR = "GET_USER_ERR";

export function getUserOk(payload) {
  return {
    type: GET_USER_OK,
    payload,
  };
}

export function getUserErr(payload) {
  return {
    type: GET_USER_ERR,
    payload,
  };
}

export const getUserService = {
  getUserDetail,
};

function getUserDetail() {
  return function (dispatch) {
    dispatch(AddOneSlotToLoadingQueue);
    return service
      .get(ApiUrl.GetUserAccountDetail)
      .then((response) => {
        dispatch(getUserOk(response));
        dispatch(RemoveOneSlotToLoadingQueue);
      })
      .catch((error) => {
        dispatch(getUserErr(error));
        dispatch(RemoveOneSlotToLoadingQueue);
        ShowNotification(error.errorMessage, NotificationMessageType.Error);
      });
  };
}
